// mobile-menu-override.js
document.addEventListener('DOMContentLoaded', function() {
    // Select all buttons that should open submenus
    const openButtons = document.querySelectorAll('[data-sliderule-open]');
    
    openButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            console.log('Button clicked');
            
            // Get the target panel
            const targetId = this.getAttribute('data-sliderule-open');
            const panel = document.getElementById(targetId);
            
            if (panel) {
                // Add visibility classes
                panel.classList.add('is-visible');
                
                // Find all animatable children
                const animatableElements = panel.querySelectorAll('[data-animates]');
                
                // Animate them in sequence
                animatableElements.forEach((el, index) => {
                    setTimeout(() => {
                        el.classList.add('is-visible');
                    }, index * 50);
                });
            }
        });
    });

    // Handle closing panels
    const closeButtons = document.querySelectorAll('[data-sliderule-close]');
    
    closeButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            
            const targetId = this.getAttribute('data-sliderule-close');
            const panel = document.getElementById(targetId);
            
            if (panel) {
                // Remove visibility classes
                panel.classList.remove('is-visible');
                
                // Reset all animated elements
                const animatableElements = panel.querySelectorAll('[data-animates]');
                animatableElements.forEach(el => {
                    el.classList.remove('is-visible');
                });
            }
        });
    });
});